export const ISO_CURRENCY = {
  AUD: "036",
  BRL: "986",
  CNY: "156",
  EUR: "978",
  GBP: "826",
  HKD: "344",
  IDR: "360",
  INR: "356",
  JPY: "392",
  MYR: "458",
  PHP: "608",
  SGD: "702",
  THB: "764",
  TWD: "901",
  USD: "840",
  VND: "704",
} as const;
